module.exports = __webpack_public_path__ + "web/img/chapter-50.d5be66d1.png";